<template><time class="date-cell" :datetime="datetime">{{ label }}</time></template>

<script>
import { formatDate } from '../../services/dateFormat'

export default {
  name: 'DateCell',
  props: {
    value: { type: [String, Number, Date], default: '' }
  },
  computed: {
    label() {
      return this.value ? formatDate(this.value, '—') : '—'
    },
    datetime() {
      if (!this.value) return undefined
      const date = this.value instanceof Date ? this.value : new Date(this.value)
      return Number.isNaN(date.getTime()) ? undefined : date.toISOString()
    }
  }
}
</script>

<style scoped>
.date-cell { font-variant-numeric: tabular-nums; white-space: nowrap; }
</style>
